/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2025, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <React.Fragment>
    <path
      fill="currentColor"
      d="m15.5214 1.3187 8 4.8888A1 1 0 0 1 24 7.0608v9.8784a.9998.9998 0 0 1-.4786.8532l-8 4.8889a.9997.9997 0 0 1-1.0429 0l-7-4.2778A.9999.9999 0 0 1 7 17.5503V16a.5.5 0 0 1 .5-.5h5.8029A4.0975 4.0975 0 0 0 16.2 14.3c.5122-.5122.8-1.207.8-1.9314v-.7372A2.7316 2.7316 0 0 0 16.2 9.7a4.0972 4.0972 0 0 0-2.8971-1.2h-5.803A.5.5 0 0 1 7 8V6.4497a1 1 0 0 1 .4786-.8533l7-4.2778a1 1 0 0 1 1.0429 0Z"
    />
    <path
      fill="currentColor"
      d="M5.0303 10.0303a.75.75 0 1 0-1.0606-1.0606L.9393 12l3.0304 3.0303a.75.75 0 0 0 1.0606-1.0606L3.8106 12.75H13a.75.75 0 0 0 0-1.5H3.8106l1.2197-1.2197Z"
    />
  </React.Fragment>,
  'MenuEgressFilled'
);
